/**
 * @generated SignedSource<<8de3ca53ec6018762c61cc4923e54d2b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type teamsQuery$variables = {
  userId: string;
  skip: boolean;
};
export type teamsQuery$data = {
  readonly teams?: {
    readonly teams: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"teamInlineFragment">;
    }>;
  };
};
export type teamsQuery = {
  variables: teamsQuery$variables;
  response: teamsQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skip"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalRef",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "platformAccess",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v9 = {
  "kind": "InlineDataFragmentSpread",
  "name": "accountBaseInlineFragment",
  "selections": [
    (v3/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/)
  ]
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetSubdomain",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "businessNumber",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latitude",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "longitude",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberUserId",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryId",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeZone",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "photoUrls",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "permissions",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showOnCatalogue",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedAt",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "addressLineOne",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "addressLineTwo",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdBy",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meta",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currencyCode",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "teamsQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "TeamsPayload",
            "kind": "LinkedField",
            "name": "teams",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "teams",
                "plural": true,
                "selections": [
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "teamInlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Account",
                        "kind": "LinkedField",
                        "name": "account",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "accountDetailsFragment"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "accountAddressFragment"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamMember",
                        "kind": "LinkedField",
                        "name": "members",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "teamMemberInlineFragment",
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Account",
                                "kind": "LinkedField",
                                "name": "account",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AccountDetailConnect",
                                    "kind": "LinkedField",
                                    "name": "accountDetailConnect",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "InlineDataFragmentSpread",
                                        "name": "accountConnectDetailInlineFragment",
                                        "selections": [
                                          (v10/*: any*/),
                                          (v11/*: any*/),
                                          (v12/*: any*/),
                                          (v13/*: any*/),
                                          (v14/*: any*/)
                                        ]
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v15/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContactTeamMember",
                                "kind": "LinkedField",
                                "name": "contactTeamMembers",
                                "plural": true,
                                "selections": [
                                  {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "teamMemberContactFragment"
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserProfile",
                                "kind": "LinkedField",
                                "name": "memberUserProfile",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "InlineDataFragmentSpread",
                                    "name": "userProfileNameInlineFragment",
                                    "selections": [
                                      (v16/*: any*/),
                                      (v17/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "InlineDataFragmentSpread",
                                    "name": "userProfileBaseInlineFragment",
                                    "selections": [
                                      (v3/*: any*/),
                                      (v18/*: any*/),
                                      (v5/*: any*/),
                                      (v19/*: any*/),
                                      (v20/*: any*/),
                                      (v21/*: any*/)
                                    ]
                                  }
                                ],
                                "storageKey": null
                              },
                              (v22/*: any*/),
                              (v23/*: any*/),
                              (v24/*: any*/),
                              (v25/*: any*/),
                              (v8/*: any*/)
                            ]
                          }
                        ],
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "teamsQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "TeamsPayload",
            "kind": "LinkedField",
            "name": "teams",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "teams",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "account",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "website",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "urls",
                        "storageKey": null
                      },
                      (v26/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "phone",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "businessLogoUrls",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "coverPhotoUrls",
                        "storageKey": null
                      },
                      (v27/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v30/*: any*/),
                      (v19/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "zip",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamMember",
                    "kind": "LinkedField",
                    "name": "members",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Account",
                        "kind": "LinkedField",
                        "name": "account",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AccountDetailConnect",
                            "kind": "LinkedField",
                            "name": "accountDetailConnect",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              (v11/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContactTeamMember",
                        "kind": "LinkedField",
                        "name": "contactTeamMembers",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Contact",
                            "kind": "LinkedField",
                            "name": "contact",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v16/*: any*/),
                              (v17/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "source",
                                "storageKey": null
                              },
                              (v18/*: any*/),
                              (v4/*: any*/),
                              (v8/*: any*/),
                              (v31/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "unmindUserId",
                                "storageKey": null
                              },
                              (v32/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "salutation",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "dob",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "preferredName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "gender",
                                "storageKey": null
                              },
                              (v21/*: any*/),
                              (v19/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "mobilePhone",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "workPhone",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "homePhone",
                                "storageKey": null
                              },
                              (v27/*: any*/),
                              (v28/*: any*/),
                              (v29/*: any*/),
                              (v30/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "businessName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "occupation",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContactActivityHistory",
                                "kind": "LinkedField",
                                "name": "contactActivityHistories",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v10/*: any*/),
                                  (v26/*: any*/),
                                  (v8/*: any*/),
                                  (v33/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContactTeamMember",
                                "kind": "LinkedField",
                                "name": "contactTeamMembers",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TeamMember",
                                    "kind": "LinkedField",
                                    "name": "teamMember",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "UserProfile",
                                        "kind": "LinkedField",
                                        "name": "memberUserProfile",
                                        "plural": false,
                                        "selections": [
                                          (v16/*: any*/),
                                          (v17/*: any*/),
                                          (v3/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Fee",
                                    "kind": "LinkedField",
                                    "name": "fee",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v6/*: any*/),
                                      (v34/*: any*/),
                                      (v8/*: any*/),
                                      (v31/*: any*/),
                                      (v35/*: any*/),
                                      (v26/*: any*/),
                                      (v5/*: any*/),
                                      (v10/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SalesOrder",
                                "kind": "LinkedField",
                                "name": "salesOrders",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v5/*: any*/),
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "userId",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "customerEmail",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "customerFirstName",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "customerLastName",
                                    "storageKey": null
                                  },
                                  (v32/*: any*/),
                                  (v33/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "eventRecurringId",
                                    "storageKey": null
                                  },
                                  (v8/*: any*/),
                                  (v25/*: any*/),
                                  (v24/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "subAmount",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "taxAmount",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "totalAmount",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "discountAmount",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "grandAmount",
                                    "storageKey": null
                                  },
                                  (v35/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "paymentTerms",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PaymentIn",
                                    "kind": "LinkedField",
                                    "name": "paymentIns",
                                    "plural": true,
                                    "selections": [
                                      (v34/*: any*/),
                                      (v8/*: any*/),
                                      (v35/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "payerEmail",
                                        "storageKey": null
                                      },
                                      (v5/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SalesOrder",
                                        "kind": "LinkedField",
                                        "name": "salesOrder",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v5/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Payment",
                                    "kind": "LinkedField",
                                    "name": "payment",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "paidAt",
                                        "storageKey": null
                                      },
                                      (v34/*: any*/),
                                      (v35/*: any*/),
                                      (v4/*: any*/),
                                      (v8/*: any*/),
                                      (v25/*: any*/),
                                      (v24/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SessionLimitPayload",
                                "kind": "LinkedField",
                                "name": "sessionLimits",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sessionLimitType",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "amountRemaining",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "expiryDate",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v8/*: any*/),
                          (v25/*: any*/),
                          (v24/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserProfile",
                        "kind": "LinkedField",
                        "name": "memberUserProfile",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v3/*: any*/),
                          (v18/*: any*/),
                          (v5/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v22/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "0ce4c3d64e61207ed0e2fb5cf4fc2894",
    "id": null,
    "metadata": {},
    "name": "teamsQuery",
    "operationKind": "query",
    "text": "query teamsQuery(\n  $userId: ID!\n  $skip: Boolean!\n) {\n  teams(userId: $userId) @skip(if: $skip) {\n    teams {\n      ...teamInlineFragment\n      id\n    }\n  }\n}\n\nfragment accountAddressFragment on Account {\n  addressLineOne\n  addressLineTwo\n  city\n  state\n  countryId\n  zip\n}\n\nfragment accountBaseInlineFragment on Account {\n  id\n  externalRef\n  name\n  platformAccess\n  createdAt\n}\n\nfragment accountConnectDetailInlineFragment on AccountDetailConnect {\n  type\n  meetSubdomain\n  businessNumber\n  latitude\n  longitude\n}\n\nfragment accountDetailsFragment on Account {\n  website\n  urls\n  description\n  phone\n  businessLogoUrls\n  coverPhotoUrls\n}\n\nfragment contactActivityHistoryInlineFragment on ContactActivityHistory {\n  id\n  type\n  description\n  createdAt\n  meta\n}\n\nfragment contactFragment on Contact {\n  id\n  firstName\n  lastName\n  source\n  email\n  accountId\n  createdAt\n  createdBy\n  unmindUserId\n  status\n  salutation\n  dob\n  preferredName\n  gender\n  photoUrls\n  countryId\n  mobilePhone\n  workPhone\n  homePhone\n  addressLineOne\n  addressLineTwo\n  city\n  state\n  businessName\n  occupation\n  contactActivityHistories {\n    ...contactActivityHistoryInlineFragment\n    id\n  }\n  contactTeamMembers {\n    ...contactTeamMemberInlineFragment\n    id\n  }\n  salesOrders {\n    ...salesOrderBaseFragment\n    ...salesOrderAmountFragment\n    ...salesOrderPaymentsFragment\n    ...salesOrderBaseInlineFragment\n    ...salesOrderAmountInlineFragment\n    ...salesOrderPaymentsInlineFragment\n    id\n  }\n  ...contactSessionLimitsRemainingFragment\n  ...contactSessionLimitsRemainingInlineFragment\n}\n\nfragment contactSessionLimitsRemainingFragment on Contact {\n  sessionLimits {\n    sessionLimitType\n    amountRemaining\n  }\n}\n\nfragment contactSessionLimitsRemainingInlineFragment on Contact {\n  sessionLimits {\n    sessionLimitType\n    amountRemaining\n    expiryDate\n  }\n}\n\nfragment contactTeamMemberInlineFragment on ContactTeamMember {\n  id\n  teamMember {\n    id\n    memberUserProfile {\n      firstName\n      lastName\n      id\n    }\n  }\n  fee {\n    ...feeInlineFragment\n    id\n  }\n}\n\nfragment feeInlineFragment on Fee {\n  id\n  name\n  amount\n  createdAt\n  createdBy\n  currencyCode\n  description\n  externalRef\n  type\n}\n\nfragment paymentBaseInlineFragment on Payment {\n  id\n  paidAt\n  amount\n  currencyCode\n  accountId\n  createdAt\n  updatedAt\n  deletedAt\n}\n\nfragment salesOrderAmountFragment on SalesOrder {\n  subAmount\n  taxAmount\n  totalAmount\n  discountAmount\n  grandAmount\n  currencyCode\n  paymentTerms\n}\n\nfragment salesOrderAmountInlineFragment on SalesOrder {\n  subAmount\n  taxAmount\n  totalAmount\n  discountAmount\n  grandAmount\n  currencyCode\n  paymentTerms\n}\n\nfragment salesOrderBaseFragment on SalesOrder {\n  id\n  externalRef\n  accountId\n  userId\n  customerEmail\n  customerFirstName\n  customerLastName\n  status\n  meta\n  eventRecurringId\n  createdAt\n  updatedAt\n  deletedAt\n}\n\nfragment salesOrderBaseInlineFragment on SalesOrder {\n  id\n  externalRef\n  accountId\n  userId\n  customerEmail\n  customerFirstName\n  customerLastName\n  status\n  totalAmount\n  grandAmount\n  currencyCode\n  meta\n  eventRecurringId\n  createdAt\n  updatedAt\n  deletedAt\n  payment {\n    ...paymentBaseInlineFragment\n    id\n  }\n}\n\nfragment salesOrderPaymentsFragment on SalesOrder {\n  paymentIns {\n    amount\n    createdAt\n    currencyCode\n    payerEmail\n    externalRef\n    salesOrder {\n      id\n      externalRef\n    }\n    id\n  }\n}\n\nfragment salesOrderPaymentsInlineFragment on SalesOrder {\n  paymentIns {\n    amount\n    createdAt\n    currencyCode\n    payerEmail\n    externalRef\n    salesOrder {\n      id\n      externalRef\n    }\n    id\n  }\n}\n\nfragment teamInlineFragment on Team {\n  id\n  accountId\n  account {\n    ...accountBaseInlineFragment\n    ...accountDetailsFragment\n    ...accountAddressFragment\n    id\n  }\n  members {\n    ...teamMemberInlineFragment\n    id\n  }\n}\n\nfragment teamMemberContactFragment on ContactTeamMember {\n  id\n  contact {\n    ...contactFragment\n    id\n  }\n  createdAt\n  updatedAt\n  deletedAt\n}\n\nfragment teamMemberInlineFragment on TeamMember {\n  id\n  account {\n    ...accountBaseInlineFragment\n    accountDetailConnect {\n      ...accountConnectDetailInlineFragment\n      id\n    }\n    id\n  }\n  memberUserId\n  contactTeamMembers {\n    ...teamMemberContactFragment\n    id\n  }\n  memberUserProfile {\n    ...userProfileNameInlineFragment\n    ...userProfileBaseInlineFragment\n    id\n  }\n  permissions\n  showOnCatalogue\n  deletedAt\n  updatedAt\n  createdAt\n}\n\nfragment userProfileBaseInlineFragment on UserProfile {\n  id\n  email\n  externalRef\n  countryId\n  timeZone\n  photoUrls\n}\n\nfragment userProfileNameInlineFragment on UserProfile {\n  firstName\n  lastName\n}\n"
  }
};
})();

(node as any).hash = "ce7817e8352c79cb4913c4f4ee74d3b7";

export default node;
